const VOCABULARY_STATUS_KEY = 'vocabularyStatus';

export const getVocabularyStatusKey = (videoId) => {
  return `${VOCABULARY_STATUS_KEY}_${videoId}`;
};

export const getVocabularyStatus = (videoId) => {
  try {
    const key = getVocabularyStatusKey(videoId);
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : {};
  } catch (error) {
    console.error('获取词汇状态失败:', error);
    return {};
  }
};

export const saveVocabularyStatus = (videoId, statusMap) => {
  try {
    const key = getVocabularyStatusKey(videoId);
    localStorage.setItem(key, JSON.stringify(statusMap));
  } catch (error) {
    console.error('保存词汇状态失败:', error);
  }
};

export const updateItemStatus = (videoId, itemId, itemType, status) => {
  const statusMap = getVocabularyStatus(videoId);
  const key = `${itemType}_${itemId}`;
  
  if (statusMap[key] === status) {
    statusMap[key] = 'unmarked';
  } else {
    statusMap[key] = status;
  }
  
  saveVocabularyStatus(videoId, statusMap);
  
  // 触发自定义事件，通知其他组件状态已更新
  window.dispatchEvent(new CustomEvent('vocabularyStatusUpdated', {
    detail: { videoId, itemId, itemType, status: statusMap[key] }
  }));
  
  return statusMap;
};

export const getItemStatus = (videoId, itemId, itemType) => {
  const statusMap = getVocabularyStatus(videoId);
  const key = `${itemType}_${itemId}`;
  return statusMap[key] || 'unmarked';
};

export const enrichVocabularyWithStatus = (videoId, vocabulary) => {
  const statusMap = getVocabularyStatus(videoId);
  
  return {
    words: (vocabulary.words || []).map(word => ({
      ...word,
      status: getItemStatus(videoId, word.id, 'word')
    })),
    phrases: (vocabulary.phrases || []).map(phrase => ({
      ...phrase,
      status: getItemStatus(videoId, phrase.id, 'phrase')
    })),
    expressions: (vocabulary.expressions || []).map(expression => ({
      ...expression,
      status: getItemStatus(videoId, expression.id, 'expression')
    }))
  };
};

export const clearAllVocabularyStatus = () => {
  const keys = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith(VOCABULARY_STATUS_KEY)) {
      keys.push(key);
    }
  }
  keys.forEach(key => localStorage.removeItem(key));
};
